import { useMemo } from "react";
import InrixVolumeUrlKeys from "../../../../../../../constant/InrixVolumeUrlKeys";
import type { InrixVolumesViewOrderItemSummary } from "../../../../../../../types/ViewOrderItem/InrixVolumes/InrixVolumesViewOrderItemSummary";
import {
  InrixVolumeTimePeriod,
  useGetOrderItemInrixVolumeParams,
} from "../../controls";
import createStyleFunction from "./styleFunction";
import ViewOrderItemVectorTileLayer from "../ViewOrderItemVectorTileLayer";

interface ViewOrderItemInrixVolumeVectorTileLayerProps {
  visible: boolean;
  summary: InrixVolumesViewOrderItemSummary | null;
}

const ViewOrderItemInrixVolumeVectorTileLayer = ({
  visible,
  summary,
}: ViewOrderItemInrixVolumeVectorTileLayerProps) => {
  const { timePeriod, timeIndex, timeSegment } =
    useGetOrderItemInrixVolumeParams();

  const queryParams = useMemo(() => {
    const params = new URLSearchParams({
      [InrixVolumeUrlKeys.TIME_PERIOD]: timePeriod,
    });

    if (
      timePeriod === InrixVolumeTimePeriod.FIFTEEN_MINS &&
      timeIndex !== null
    ) {
      params.set(InrixVolumeUrlKeys.TIME_INDEX, String(timeIndex));
    }

    return params;
  }, [timeIndex, timePeriod]);

  const styleFunction = useMemo(() => {
    return createStyleFunction({ summary, timePeriod, timeIndex, timeSegment });
  }, [
    summary?.adtMax,
    summary?.adtMin,
    summary?.volMax,
    summary?.volMin,
    timeIndex,
    timePeriod,
    timeSegment,
  ]);

  return (
    <ViewOrderItemVectorTileLayer
      visible={visible}
      style={styleFunction}
      queryParams={queryParams}
    />
  );
};

export default ViewOrderItemInrixVolumeVectorTileLayer;
